import React from 'react';

export default function InvoiceMemberCell({ name, email, path }) {
  const displayName = name || email || '—';
  const showEmailSubtitle = name && email && name !== email;

  return (
    <div>
      {path ? (
        <a href={path}>{displayName}</a>
      ) : (
        <span>{displayName}</span>
      )}
      {showEmailSubtitle && <div className="text-muted small">{email}</div>}
    </div>
  );
}
